/*
 * @format
 */
import React from 'react';
import PropTypes from 'prop-types';
import Tabs from '../../sharedComponents/Tabs';
import Panel from '../../sharedComponents/Panel';

export default class TabItems extends React.Component {
    static propTypes = {
        tabs: PropTypes.arrayOf(PropTypes.shape({ label: PropTypes.string, content: PropTypes.any }))
    };

    static defaultProps = {
        tabs: []
    };

    render() {
        const { tabs } = this.props;
        if (!tabs.length) return null;

        return (
            <Tabs>
                {tabs.map((tab) => (
                    <Panel key={tab.label} label={tab.label}>
                        <summary className="rec-full-content-wrap">{tab.content}</summary>
                    </Panel>
                ))}
            </Tabs>
        );
    }
}
